export const HistoryEmptyIcon = () => (
    <svg
        width="132"
        height="132"
        viewBox="0 0 132 132"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M25.5283 68.1042C26.6837 67.7265 27.3159 66.4783 26.9403 65.3162C26.5648 64.1541 25.3238 63.5182 24.1684 63.8959C23.013 64.2736 22.3808 65.5219 22.7564 66.684C23.1319 67.8461 24.3729 68.4819 25.5283 68.1042Z"
            fill="#C0C0C0"
        />
        <path
            d="M37.9072 60.5572L32.1878 36.1304C31.7479 34.2718 32.8917 32.5018 34.6516 32.0593L72.3996 23.032L93.7814 37.6349L107.156 91.3561C107.596 93.2147 106.452 94.9848 104.692 95.4273L52.6017 107.818C50.7539 108.26 48.9941 107.11 48.5541 105.34L37.4673 58.6986"
            fill="#D8D8D8"
        />
        <path
            d="M103.812 58.8755L83.6622 110.384C82.9583 112.154 81.0225 112.951 79.2627 112.243L29.7238 91.8871C27.964 91.179 27.1721 89.232 27.876 87.4619L54.5372 21.6158C55.2412 19.8458 57.177 19.0493 58.9368 19.7573L94.925 34.5372L103.812 58.8755Z"
            fill="#E1E1E1"
        />
        <path
            d="M94.8372 34.5371L89.1178 48.6976C88.3258 50.6446 89.3817 53.0342 91.3175 53.8307L103.812 58.8754"
            fill="#C0C0C0"
        />
        <path
            d="M98.6208 100.472C98.6208 102.33 97.1249 103.835 95.2771 103.835H41.7787C39.9309 103.835 38.4351 102.33 38.4351 100.472V29.3155C38.4351 27.4569 39.9309 25.9524 41.7787 25.9524H80.5827L98.0048 45.1575L98.3568 77.3725L98.6208 100.472Z"
            fill="#F3F3F3"
        />
        <path
            d="M88.7658 83.4793H56.6492C56.1212 83.4793 55.6813 83.0368 55.6813 82.5058C55.6813 81.9747 56.1212 81.5322 56.6492 81.5322H88.7658C89.2938 81.5322 89.7337 81.9747 89.7337 82.5058C89.6457 83.0368 89.2938 83.4793 88.7658 83.4793Z"
            fill="white"
        />
        <path
            d="M52.6895 83.4793H47.0581C46.5302 83.4793 46.0902 83.0368 46.0902 82.5058C46.0902 81.9747 46.5302 81.5322 47.0581 81.5322H52.6895C53.2175 81.5322 53.6574 81.9747 53.6574 82.5058C53.6574 83.0368 53.2175 83.4793 52.6895 83.4793Z"
            fill="#C0C0C0"
        />
        <path
            d="M88.6778 74.7173H74.3353C73.8074 74.7173 73.3674 74.2748 73.3674 73.7438C73.3674 73.2128 73.8074 72.7703 74.3353 72.7703H88.6778C89.2058 72.7703 89.6457 73.2128 89.6457 73.7438C89.5577 74.3633 89.2058 74.7173 88.6778 74.7173Z"
            fill="white"
        />
        <path
            d="M68.264 74.7173H47.3221C46.7942 74.7173 46.3542 74.2748 46.3542 73.7438C46.3542 73.2128 46.7942 72.7703 47.3221 72.7703H68.264C68.7919 72.7703 69.2319 73.2128 69.2319 73.7438C69.2319 74.3633 68.7919 74.7173 68.264 74.7173Z"
            fill="white"
        />
        <path
            d="M88.9419 66.0442H83.3984C82.8705 66.0442 82.4305 65.6017 82.4305 65.0707C82.4305 64.5397 82.8705 64.0972 83.3984 64.0972H88.9419C89.4698 64.0972 89.9098 64.5397 89.9098 65.0707C89.9098 65.6017 89.4698 66.0442 88.9419 66.0442Z"
            fill="#C0C0C0"
        />
        <path
            d="M78.2069 66.0442H47.5861C47.0581 66.0442 46.6182 65.6017 46.6182 65.0707C46.6182 64.5397 47.0581 64.0972 47.5861 64.0972H78.2069C78.7348 64.0972 79.1748 64.5397 79.1748 65.0707C79.1748 65.6017 78.7348 66.0442 78.2069 66.0442Z"
            fill="white"
        />
        <path
            d="M64.4804 93.0374H62.5446C62.0166 93.0374 61.5767 92.5949 61.5767 92.0639C61.5767 91.5328 62.0166 91.0903 62.5446 91.0903H64.4804C65.0083 91.0903 65.4483 91.5328 65.4483 92.0639C65.3603 92.5949 64.9203 93.0374 64.4804 93.0374Z"
            fill="white"
        />
        <path
            d="M59.0249 93.0374H47.5861C47.0581 93.0374 46.6182 92.5949 46.6182 92.0639C46.6182 91.5328 47.0581 91.0903 47.5861 91.0903H58.9369C59.4648 91.0903 59.9048 91.5328 59.9048 92.0639C59.9928 92.5949 59.5528 93.0374 59.0249 93.0374Z"
            fill="white"
        />
        <path
            d="M89.2057 57.3709H69.4957C68.9678 57.3709 68.5278 56.9284 68.5278 56.3974C68.5278 55.8663 68.9678 55.4238 69.4957 55.4238H89.2057C89.7336 55.4238 90.1736 55.8663 90.1736 56.3974C90.1736 56.9284 89.7336 57.3709 89.2057 57.3709Z"
            fill="white"
        />
        <path
            d="M63.1606 57.3709H47.8502C47.3223 57.3709 46.8823 56.9284 46.8823 56.3974C46.8823 55.8663 47.3223 55.4238 47.8502 55.4238H63.0726C63.6006 55.4238 64.0405 55.8663 64.0405 56.3974C64.0405 56.9284 63.6886 57.3709 63.1606 57.3709Z"
            fill="white"
        />
        <path
            d="M73.8953 37.7232H48.202C47.498 37.7232 46.9701 37.1922 46.9701 36.4842C46.9701 35.7761 47.498 35.2451 48.202 35.2451H73.8953C74.5992 35.2451 75.1272 35.7761 75.1272 36.4842C75.1272 37.1037 74.5112 37.7232 73.8953 37.7232Z"
            fill="#C0C0C0"
        />
        <path
            d="M57.9689 43.9185H48.202C47.498 43.9185 46.9701 43.3875 46.9701 42.6795C46.9701 41.9714 47.498 41.4404 48.202 41.4404H58.0569C58.7609 41.4404 59.2888 41.9714 59.2888 42.6795C59.2008 43.299 58.6729 43.9185 57.9689 43.9185Z"
            fill="#C0C0C0"
        />
        <path
            d="M80.5826 25.9524V41.1749C80.5826 43.2989 82.4304 45.069 84.5422 45.069H98.0048"
            fill="#E1E1E1"
        />
        <path
            d="M29.9999 101.691C30.7076 101.691 31.3365 101.137 31.3365 100.346C31.3365 99.554 30.7862 99 29.9999 99C29.2923 99 28.6633 99.554 28.6633 100.346C28.6633 101.137 29.2923 101.691 29.9999 101.691Z"
            fill="#E6E6E6"
        />
        <path
            d="M108.587 67.3456C109.295 67.3456 109.924 66.7915 109.924 66.0001C109.924 65.2086 109.373 64.6545 108.587 64.6545C107.879 64.6545 107.25 65.2086 107.25 66.0001C107.25 66.7915 107.879 67.3456 108.587 67.3456Z"
            fill="#E6E6E6"
        />
    </svg>
);
